import { en } from './en';
import { zh } from './zh';

// Combined translations object
export const translations = {
  en,
  zh,
};

// Re-export types
export type { TranslationSchema } from './en';
